import React from 'react';
import { Link } from 'react-router-dom';

export const Objetivo = ({ goal }) => {
  /**Objet6ivo */
  return (
    <div className='about-area'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-8 col-md-12'>
            <div className='about-container'>
              <h3>Objetivo</h3>
              <p>{goal && goal}</p>
              <ul>
                <li>
                  <Link to='/registro/1' className='button-default'>
                    Registro
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
